import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { Subject, fromEvent, forkJoin } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { takeUntil } from 'rxjs/operators';
import _ from 'lodash';
import { TranslateService } from '@root/shared/service/translate.service';
import { SearchHouseInGroupAndTypeService } from './search-house-in-group-and-type.service';

interface IHouse {
  id: number;
  title: string;
}
@Component({
  selector: 'host-search-house-in-group-and-type-with-input',
  templateUrl: './search-house-in-group-and-type-with-input.component.html',
  styleUrls: ['./search-house-in-group-and-type-with-input.component.scss'],
})
// @deprecated
export class SearchHouseInGroupAndTypeWithInputComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() allowMultiSelect = false;
  @Input() showWidth = null;
  @Input() noBorder = false;
  @Input() defaultHouses: Array<Number> = null;
  @Input() defaultHouseTitle: string; // @deprecated
  @Input() borderRadius = '4px';

  @Output() checkedHousesChange = new EventEmitter<Array<IHouse>>();

  @ViewChild('houseSelectPanel')
  houseSelectPanel: TemplateRef<any>;
  @ViewChild('houseSelectModal') houseSelectModal;
  // @ViewChild('houseInput', { static: false }) houseInput;
  houseInfo = null;
  houseModal;
  open = false;
  houseGroupList = [];
  houseTypeList = [];
  allHouseList = [];
  searchHouseParams = {
    page: 1,
    page_size: 10000,
    house_type_id: null,
    group_id: null,
  };
  checkedHouses = [];
  titleFirstChange = true;

  private destroy$ = new Subject();
  constructor(
    private modalService: NzModalService,
    private searchService: SearchHouseInGroupAndTypeService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {

    this.getListToCheckHouses();
    this.getHouseList();
  }

  ngOnChanges() {
    // if (this.defaultHouseTitle && this.titleFirstChange) {
    //   this.houseInfo = this.defaultHouseTitle;
    //   this.titleFirstChange = false;
    // }
  }

  ngAfterViewInit() {
    fromEvent(document, 'click')
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: MouseEvent) => {
        const path =
          _.get(event, 'path') || (event.composedPath && event.composedPath());
        let flag = false;
        let i = 0;
        _.forEach(path, (p) => {
          i++;
          if (i > 10) {
            return;
          }
          const className = _.get(p, 'className');
          const temp = _.split(className, ' ');
          if (temp.indexOf('date') !== -1 || temp.indexOf('template') !== -1) {
            flag = true;
            return;
          }
        });
        if (!flag) {
          // this.cancelData();
          if (this.houseModal) {
            this.houseModal.destroy();
          }
          this.open = false;
        }
      });
  }

  /** @deprecated */
  showHouseSelectPanel() {
    const modalStyle = {
      position: 'absolute',
      left: this.houseSelectModal.nativeElement.parentNode.getBoundingClientRect()
        .left,
      top:
        this.houseSelectModal.nativeElement.parentNode.getBoundingClientRect()
          .top + 36,
    };
    if (!this.open) {
      _.assign(this.searchHouseParams, {
        group_id: null,
        house_type_id: null,
      });
      // this.getHouseList();
      this.houseModal = this.modalService.create({
        nzTitle: null,
        nzContent: this.houseSelectPanel,
        nzFooter: null,
        nzWidth: 472,
        nzMask: false,
        nzClosable: false,
        nzStyle: modalStyle,
        nzWrapClassName: 'overlap-modal',
      });
    }
    this.open = !this.open;
  }

  getListToCheckHouses() {
    forkJoin([
      this.searchService.getGroupList(),
      this.searchService.getHouseTypeList(),
    ]).subscribe((res) => {
      if (res) {
        this.houseGroupList = this.initGroupList(_.get(res[0], 'data.list'));
        this.houseTypeList = this.initTypeList(_.get(res[1], 'data.list'));
      }
    });
  }

  getHouseList() {
    this.searchService
      .getTransactionHouseList(this.searchHouseParams)
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.allHouseList = this.initHouseList(_.get(res, 'data.list'));

          /**
           * 暂时处理方式：延迟save，将处理逻辑交给组件本身
           */
          if (this.defaultHouses && this.titleFirstChange) {
            // this.houseInfo = this.defaultHouseTitle;
            setTimeout(() => {
              this.save();
            }, 0);
            this.titleFirstChange = false;
          }
        }
      });
  }

  initGroupList(data) {
    const temp = [];
    temp.push({
      thisGroupChecked: false,
      // name: '全部分组',
      name: this.translateService.syncGet('house.all_group'),
      id: -1,
    });
    for (let i = 0; i < data.length; i++) {
      temp.push({
        thisGroupChecked: false,
        name: data[i].name,
        id: data[i].group_id,
      });
    }
    return temp;
  }

  initTypeList(data) {
    if (data.length === 0) {
      return data;
    }
    const temp = [];
    temp.push({
      thisTypeChecked: false,
      // title: '全部房型',
      title: this.translateService.syncGet('component.relate.all_house_types'),
      id: -1,
    });
    _.forEach(data, (type) => {
      temp.push({
        ...type,
        thisTypeChecked: false,
      });
    });
    return temp;
  }

  initHouseList(data) {
    const temp = [];
    _.forEach(data, (type) => {
      _.forEach(type, (house) => {
        _.assign(house, {
          checked: false,
          disabled: false,
        });
      });
      temp.push(type);
    });
    return temp;
  }

  selectedHousesChange(house) {
    this.checkedHouses = house;
  }

  groupChange(id) {
    _.assign(this.searchHouseParams, {
      group_id: id,
      house_type_id: null,
    });
    this.getHouseList();
  }

  typeChange(id) {
    _.assign(this.searchHouseParams, {
      house_type_id: id,
      group_id: null,
    });
    this.getHouseList();
  }

  cancel() {
    this.open = false;
    // this.houseModal.destroy();
  }

  save() {
    if (this.allowMultiSelect) {
      // this.houseInfo = `${this.checkedHouses.length}个房间`;
      const len = this.checkedHouses.length;
      this.houseInfo =
        len > 1
          ? this.translateService.syncGet('component.search.houses_total', {
              total: len,
            })
          : this.translateService.syncGet('component.search.house_total', {
              total: len,
            });
    } else {
      this.houseInfo = this.checkedHouses[0].title;
    }
    this.checkedHousesChange.emit(this.checkedHouses);
    this.open = false;
    // this.houseModal.destroy();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
